import React, { useState } from 'react';
import { Form, Input, Button, Typography, message, theme } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { authApi } from '@/api/auth';

const { Title, Text } = Typography;

const ResetPassword: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const resetToken = searchParams.get('token') || '';
  const { token: themeToken } = theme.useToken();

  const onFinish = async (values: { password: string }) => {
    setLoading(true);
    try {
      await authApi.resetPassword(resetToken, values.password);
      setSuccess(true);
      message.success('Senha redefinida com sucesso!');
    } catch (error: any) {
      message.error(error.response?.data?.error || 'Erro ao redefinir senha. Token pode estar expirado.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: themeToken.colorBgLayout,
    }}>
      <div style={{
        background: themeToken.colorBgContainer,
        padding: 40,
        borderRadius: 12,
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        width: '100%',
        maxWidth: 400,
      }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <Title level={3} style={{ margin: 0 }}>Redefinir Senha</Title>
          <Text type="secondary">Digite sua nova senha</Text>
        </div>

        {success ? (
          <div style={{ textAlign: 'center' }}>
            <Text>Sua senha foi redefinida com sucesso!</Text>
            <div style={{ marginTop: 24 }}>
              <Button type="primary" onClick={() => navigate('/login')}>
                Ir para o Login
              </Button>
            </div>
          </div>
        ) : !resetToken ? (
          <div style={{ textAlign: 'center' }}>
            <Text type="danger">Token de redefinição não encontrado.</Text>
            <div style={{ marginTop: 24 }}>
              <Link to="/forgot-password">Solicitar novo link</Link>
            </div>
          </div>
        ) : (
          <Form
            name="reset-password"
            onFinish={onFinish}
            layout="vertical"
            size="large"
          >
            <Form.Item
              name="password"
              rules={[
                { required: true, message: 'Por favor, insira a nova senha' },
                { min: 8, message: 'A senha deve ter pelo menos 8 caracteres' },
              ]}
            >
              <Input.Password prefix={<LockOutlined />} placeholder="Nova senha" />
            </Form.Item>

            <Form.Item
              name="password_confirm"
              dependencies={['password']}
              rules={[
                { required: true, message: 'Por favor, confirme a senha' },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('password') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('As senhas não conferem'));
                  },
                }),
              ]}
            >
              <Input.Password prefix={<LockOutlined />} placeholder="Confirmar nova senha" />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" loading={loading} block>
                Redefinir Senha
              </Button>
            </Form.Item>

            <div style={{ textAlign: 'center' }}>
              <Link to="/login">Voltar para o login</Link>
            </div>
          </Form>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;
